import { DELETE_USERS, LOAD_USERS, UPDATE_USER } from '../actions/actions';
import User from '../../models/user';

interface InitialState {
  users: User[];
}

const initialState: InitialState = {
  users: [],
};

function reducer(state = initialState, action: any) {
  switch (action.type) {
    case LOAD_USERS:
      return { ...state, users: JSON.parse(localStorage.getItem('::memory::users') || '[]') };

    case UPDATE_USER: {
      const users = [...state.users];
      const user = action.payload.user;

      const matchedUser = users.find((curUser) => curUser.name === user.name);
      const index = users.findIndex((curUser) => curUser.name === user.name);

      if (matchedUser) {
        users.splice(index, 1, user);
        return { ...state, users: saveUsers(sortUsers(users)) };
      } else {
        return { ...state, users: saveUsers(sortUsers([...users, user])) };
      }
    }

    case DELETE_USERS:
      return { ...state, users: saveUsers([]) };

    default:
      return state;
  }
}

function sortUsers(users: User[]): User[] {
  var array = users.map((a) => a.guesses);
  array = array.filter((a, i) => array.indexOf(a) === i);

  return array
    .map((a) => users.filter((b) => b.guesses === a))
    .sort((a, b) => a[0].guesses - b[0].guesses)
    .reduce((a, b, i) => [...a, ...b.map((c) => ({ ...c, rating: i + 1 }))], []);
}

function saveUsers(users: User[]): User[] {
  localStorage.setItem('::memory::users', JSON.stringify(users));
  return users;
}

export default reducer;
